export const useApi = () => {
  const app = useNuxtApp()

  return app.$api
}
